<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
/* Global styles moved to main.js or kept here if needed */
</style>
